// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"9fffdc4d","222":"3505e659","280":"2c14e764","563":"0d02876e","567":"fe83684d","739":"0d02876e","860":"51257e3e"}[chunkId] + ".chunk.css";
};